import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
/* import GradeIcon from '@material-ui/icons/Grade';
import GradeOutlinedIcon from '@material-ui/icons/GradeOutlined'; */
import { TextField, Divider, Button, Grid } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import StandardList from '../Complements/StandardList';

  const validate = values => {
    const error  = {}
    if (!values.data) {
        error.data = `El campo obligatorio`
    }
    return error
}

const RenderDescriptionForm = props => {
    const { label, handleSubmit, valid, positive, getBack } = props
    return (
        <form onSubmit={ handleSubmit } >
            <Field
                name="data"
                id="data"
                component={ RenderTextFieldRedux }
                label={label}
                fullWidth
                multiline
                //autoFocus = {true}
                rows={3}
            />
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Grid container justify="center" spacing={2}>
                        <Button fullWidth variant="contained" color="primary" disabled={!valid}  type="submit" >{positive}</Button>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container justify="center" spacing={2} >
                        <Button  variant="contained" color="primary" onClick = {() => getBack(true) }>Cancelar</Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}

const RenderDescriptionFormRedux = reduxForm(
    {
      form: 'RenderDescriptionForm',
      validate
    }
)(RenderDescriptionForm)

const TaxeInfoPanel = props => {
    const { select, options, findValue, getBack, processPayment, payerData } = props
    // const classes = useStyles()
    const sum = (key, array) =>  {
        if (array.length === 0) {
            return 0
        } else {
            return array.reduce((a, b) => a + (b[key] || 0), 0);
        }
    }
    const [list, setList] = useState([
        
    ])
    useEffect(() => {
        // Actualiza el título del documento usando la API del navegador
        setList([
            {id: '1', title: 'INSTITUCION', data: payerData.Institucion,             icon: 'school', 
                pstyle: { color: 'rgb(0, 0, 1)', fontWeight: 'bold', fontSize: '0.875rem'},
                sstyle: { color: 'rgb(0, 0, 1)', fontSize: '0.8rem'} },
            {id: '2', title: 'PAGADOR', data: payerData.NombrePagador,               icon: 'account_circle', 
                pstyle: { color: 'rgb(0, 0, 1)', fontWeight: 'bold', fontSize: '0.875rem'},
                sstyle: { color: 'rgb(0, 0, 1)', fontSize: '0.8rem'} },
            {id: '3', title: 'RUBRO', data: select.map(function(elem){ return elem.Rubro }).join(","),    icon: 'event', 
                pstyle: { color: 'rgb(0, 0, 1)', fontWeight: 'bold', fontSize: '0.875rem'},
                sstyle: { color: 'rgb(0, 0, 1)', fontSize: '0.8rem'} },
            {id: '4', title: 'VALOR A PAGAR', data: parseFloat(sum('Valor', select)).toFixed(2),            icon: 'monetization_on', 
                pstyle: { color: 'rgb(0, 160, 175)', fontWeight: 'bold', fontSize: '1.05rem'},
                sstyle: { color: 'rgb(0, 160, 175)', fontWeight: 'bold', fontSize: '1rem'} },
        ])
      }, [select, setList, payerData]) 
    return (
        <div >
            <Autocomplete
                fullWidth
                multiple
                disableClearable
                id="tags-standard"
                options={options}
                getOptionLabel={(option) => option.Rubro}
                defaultValue={select}
                value = {select}
                onChange = { (e, nv, reason) => {
                    if (reason === 'remove-option') {
                        const del = select.filter(s => !nv.includes(s))
                        const index = options.findIndex(x => x === del[0])
                        findValue( index )
                    } else {
                        const index = options.findIndex(x => x ===nv[nv.length-1])
                        //console.log(index, nv)
                        findValue( index )
                    }
                    
                    
                }}
                renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    variant="standard"
                    label="Seleccione Rubros"
                    placeholder="Rubros"
                />
                )}
            />
            <br/>
            <Divider></Divider>
            {
                        /*<Card>
                <CardContent>
                     true ?
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<GradeOutlinedIcon />}
                            onClick = { () => console.log('agregar a favoritos') }
                        >Agregar a favoritos</Button> :
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<GradeIcon />}
                            disabled
                        >Favorito</Button>
                    <br/>
                    <Divider></Divider> 
                    </CardContent>
            </Card>*/
                    }
                    <StandardList
                        dataList ={ list}
                        primary = {'title'}
                        secondary = {'data'}
                        selectItem = {(val) => {/*console.log(val)*/}}
                        icon = {'school'}
                    />
                    <Divider></Divider>
                    <br/>    
                    {
                        <RenderDescriptionFormRedux  
                            label = "Descripcion" onSubmit = {(data) => processPayment(data) } positive ={'Pagar'} getBack= {getBack}/>
                    }
        </div>
    );
};

TaxeInfoPanel.propTypes = {
    select: PropTypes.array.isRequired,
    options: PropTypes.array.isRequired,
    findValue: PropTypes.func.isRequired,
    getBack: PropTypes.func.isRequired,
    processPayment: PropTypes.func.isRequired,
};

export default TaxeInfoPanel;